module.exports = __webpack_public_path__ + "img/NR.6b72bbc1.svg";